import { useCallback } from 'react';

const useCalendarDnDMapping = (
  calendarItems = [],
) => {
  /**
   * Returns a map of items that are under a given session break
   */
  const getItemsUnderSessionBreak = useCallback(
    (currentItem) => {
      if (!currentItem || currentItem.type !== 'session_break') return {};

      const currentIndex = calendarItems.findIndex(
        (c) => c.assignedId === currentItem.assignedId,
      );
      if (currentIndex === -1) return {};

      const result = {};
      let reachedNextBreak = false;

      calendarItems.forEach((calItem, i) => {
        if (i <= currentIndex || reachedNextBreak) return;
        if (calItem.type === 'session_break') {
          reachedNextBreak = true;
          return;
        }
        result[calItem.assignedId] = calItem;
      });

      return result;
    },
    [calendarItems],
  );

  /**
   * Find the last session break above a given item in calendarItems.
   * Returns the session break object, or null if there is none.
   */
  const getSessionBreakAbove = useCallback(
    (currentItem) => {
      if (!currentItem || currentItem.type === 'session_break') return null;
      let sb = null;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < calendarItems.length; i++) {
        if (calendarItems[i]?.assignedId === currentItem?.assignedId) break;
        if (calendarItems[i]?.type === 'session_break') sb = calendarItems[i];
      }
      return sb;
    },
    [calendarItems],
  );

  return {
    getItemsUnderSessionBreak,
    getSessionBreakAbove,
  };
};

export default useCalendarDnDMapping;
